import { render, staticRenderFns } from "./TaskTemplatesTable.vue?vue&type=template&id=aab4fba6"
import script from "./TaskTemplatesTable.vue?vue&type=script&lang=ts"
export * from "./TaskTemplatesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports